import { Box, useMediaQuery } from "@mui/material";
import { ResumeBalance } from "./resume-balance";
import { ContainerHomeStyled } from "./styles";
import { NormalText } from "../../shared/styles";
import { useGetUser } from "../../hooks/useGetUser";
import { Loader } from "../../shared/loader/loader";
import { PaymentsContainer } from "./payments-container";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getBalances } from "../../redux/actions/transactions.actions";

export const HomeContainer = () => {
  const { user, credentials, isLoadingCredentials, isLoadingUser } =
    useGetUser();
  const {
    data: balances,
    isLoading: isLoadingBalances,
    isError: isErrorBalances,
  } = useSelector((state) => state.transactions.balances);

  const isDesktop = useMediaQuery("(min-width: 1124px)");
  const dispatch = useDispatch();

  useEffect(() => {
    if (credentials?.id && balances === null) {
      dispatch(getBalances(credentials?.id));
    }
  }, [dispatch, credentials?.id, balances]);

  if (isLoadingUser || isLoadingCredentials || isLoadingBalances) {
    return <Loader />;
  }

  if (!credentials?.id) {
    return (
      <NormalText>
        You need credentials to see your balance and make transactions, contact
        support to get them.
      </NormalText>
    );
  }

  return (
    <ContainerHomeStyled>
      <Box
        display={"flex"}
        gap={"24px"}
        flexDirection={isDesktop ? "row" : "column-reverse"}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={"24px"}
          width={"100%"}
        >
          <ResumeBalance
            credentials={credentials}
            isErrorBalances={isErrorBalances}
            balances={balances}
          />
          <PaymentsContainer
            user={user}
            credentials={credentials}
          />
        </Box>
      </Box>
    </ContainerHomeStyled>
  );
};
